module.exports = __webpack_public_path__ + "static/EventHackathon-50d6ebd61814792432d8fba3723b07c7.jpg";